
import { IPSResultReport } from '@/types/processingSteps'
import { Component, Vue } from 'vue-property-decorator'
import { IProject } from "@/types/projects"

@Component
export default class ResultReportSummaryMixin extends Vue {
  resultReport: IPSResultReport | null = null
  project: IProject | null = null

  get summaryItems () {
    return [
      this.resultReportDetails
    ]
  }

  get resultReportDetails (): { title: string, items: { title: string, values: string[]}[]} {
    return {
      title: this.$gettext('Result report'),
      items: [
        {
          title: this.$gettext('Title'),
          values: [this.resultReport.title]
        }
      ]
    }
  }

  get contactPersonDetails () {
    if (this.resultReport.public_contact_person) {
      return {
        title: this.$gettext('Contact person'),
        items: [
          {
            title: this.$gettext('Contact person\'s name'),
            values: [this.resultReport.public_contact_person.addressable_name]
          },
          {
            title: this.$gettext('Email address'),
            values: [this.resultReport.public_contact_person.email]
          },
          {
            title: this.$gettext('Contact person\'s phone number'),
            values: [this.resultReport.public_contact_person.phone]
          }
        ]
      }
    } else {
      return {
        title: this.$gettext('Contact person'),
        items: [
          {
            title: this.$gettext('Contact person\'s name'),
            values: []
          },
          {
            title: this.$gettext('Email address'),
            values: []
          },
          {
            title: this.$gettext('Contact person\'s phone number'),
            values: []
          }
        ]
      }
    }
  }
}
